import { type ReactNode } from 'react';
import { Wordmark } from './Wordmark';

/**
 * Layout das telas de autenticação do portal (primeiro acesso, login,
 * recuperação). Única tela onde o wordmark aparece grande e centralizado
 * (DESIGN-FOUNDATION §6.8). Coluna estreita, uma ação óbvia.
 */
export function TelaAuthPortal({ children }: { children: ReactNode }): ReactNode {
  return (
    <div className="flex min-h-screen flex-col items-center bg-fundo px-5 py-12">
      <div className="w-full max-w-[400px]">
        <div className="mb-10 flex justify-center">
          <Wordmark largura={180} />
        </div>
        {children}
      </div>
    </div>
  );
}
